<template>
    <div>
        <div class="ix-filter-summary" v-if="formattedFilters.length > 0">
            Filtre{{ formattedFilters.length > 1 ? 's' : '' }} actif{{ formattedFilters.length > 1 ? 's' : '' }}:
            <span v-for="filter in formattedFilters" class="ix-filter-chip" v-on:click="removeFilter(filter)">
                {{ filter.label }}
                <span class="ix-filter-chip-value">{{ filter.value ? ': ' + filter.value : '' }}</span>
                <i class="far fa-times"></i>
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        filters: String,
    },
    data() {
        return {
            inputValueBlackList: ['state', 'sync_status', 'is_under_contract', 'type', 'sendable_type', 'invoice_id_from', 'invoice_id_to', 'bill_id_from', 'bill_id_to', 'credit_supplier_id_from', 'credit_supplier_id_to', 'credit_note_id_from', 'credit_note_id_to'],
            formattedFilters: [],
        };
    },
    methods: {
        format: function () {
            for (const [key, value] of Object.entries(JSON.parse(this.filters))) {
                if (key !== 'orderBy' && key !== 'paymentType' && key !== 'invoice_id_from' 
                    && key !== 'invoice_id_to' && key !== 'bill_id_from' && key !== 'bill_id_to'
                    && key !== 'credit_supplier_id_from' && key !== 'credit_supplier_id_to'
                    && key !== 'credit_note_id_from' && key !== 'credit_note_id_to') {
                    if (typeof value === 'object') {
                        for (const [keyObj, valueObj] of Object.entries(value)) {
                            if (valueObj) {
                                var name = key + '[' + keyObj + ']';
                                var element = $('#list-filters').find($('[name="' + name + '"]'))
                                if (element.length) {
                                    this.pushToFilters(element, name, valueObj)
                                }
                            }

                        }
                    } else {
                        var element = $('#list-filters').find($('[name="' + key + '"]'))
                        if (element.length) {
                            if (element.prop("tagName").toLowerCase() === 'select') {
                                value = element.find($("option:selected")).text()
                            }
                            this.pushToFilters(element, key, value)
                        }
                    }
                }
            }
        },
        removeFilter: function (filter) {
            // Clean input value
            const element = $('#list-filters').find($('[name="' + filter.name + '"]'))
            if (element) {
                element.val('')

                if(filter.name == 'invoice_name_from' &&  $('#list-filters').find($('[name="invoice_id_from"]').length)){
                    $('#list-filters').find($('[name="invoice_id_from"]')).val('');
                }

                if(filter.name == 'invoice_name_to' &&  $('#list-filters').find($('[name="invoice_id_to"]').length)){
                    $('#list-filters').find($('[name="invoice_id_to"]')).val('');
                }

                if(filter.name == 'bill_name_from' &&  $('#list-filters').find($('[name="bill_id_from"]').length)){
                    $('#list-filters').find($('[name="bill_id_from"]')).val('');
                }

                if(filter.name == 'bill_name_to' &&  $('#list-filters').find($('[name="bill_id_to"]').length)){
                    $('#list-filters').find($('[name="bill_id_to"]')).val('');
                }

                if(filter.name == 'credit_supplier_name_from' &&  $('#list-filters').find($('[name="credit_supplier_id_from"]').length)){
                    $('#list-filters').find($('[name="credit_supplier_id_from"]')).val('');
                }

                if(filter.name == 'credit_supplier_name_to' &&  $('#list-filters').find($('[name="credit_supplier_id_to"]').length)){
                    $('#list-filters').find($('[name="credit_supplier_id_to"]')).val('');
                }

                if(filter.name == 'credit_note_name_from' &&  $('#list-filters').find($('[name="credit_note_id_from"]').length)){
                    $('#list-filters').find($('[name="credit_note_id_from"]')).val('');
                }

                if(filter.name == 'credit_note_name_to' &&  $('#list-filters').find($('[name="credit_note_id_to"]').length)){
                    $('#list-filters').find($('[name="credit_note_id_to"]')).val('');
                }
                // Reset form
                const form = element.closest('form');
                form.submit();
            }
        },
        pushToFilters: function (element, name, value) {
            var label = element.closest('.form-group').find('label').text().toLowerCase();
            var isSelect = element.prop("tagName").toLowerCase() === 'select';

            if ((name.endsWith('_id') || this.inputValueBlackList.includes(name) == true) && isSelect == false) {
                const count = value.split(/[,;]/).length
                value = count + ' sélection' + (count > 1 ? 's' : '');
            }

            this.formattedFilters.push({
                label: label,
                name: name,
                value: value
            })
        }
    },
    mounted() {
        this.format()
    }
}
</script>
